import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { BrlFormatCurrency, FormatPoints } from "../../../lib";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

const Label = styled.span`
  font-size: 16px;
  color: var(--text-dark, #1D1D1F);
  line-height: 1.5;
`;

const Value = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: var(--text-dark, #1D1D1F);
  line-height: 1.5;
  text-align: right;
`;

const Hr = styled.div`
  height: 1px;
  background: #D9D9D9;
`;

function formatValue(displayMode, money, points) {
  if (displayMode === "points") return `${FormatPoints(points)} pts`;
  if (displayMode === "both") {
    return `${BrlFormatCurrency(money)} ou ${FormatPoints(points)} pts`;
  }
  return BrlFormatCurrency(money);
}

export default function FinancialSummary({
  subtotalMoney,
  subtotalPoints,
  coupon,
  totalMoney,
  totalPoints,
  displayMode,
}) {
  const hasCoupon = Boolean(coupon);

  return (
    <Wrap>
      <Row>
        <Label>Subtotal</Label>
        <Value>{formatValue(displayMode, subtotalMoney, subtotalPoints)}</Value>
      </Row>
      {hasCoupon && (
        <Row>
          <Label>Cupom aplicado</Label>
          <Value>
            − {formatValue(displayMode, coupon.discountMoney, coupon.discountPoints)}
          </Value>
        </Row>
      )}
      <Hr />
      <Row>
        <Label>Total</Label>
        <Value>{formatValue(displayMode, totalMoney, totalPoints)}</Value>
      </Row>
    </Wrap>
  );
}

FinancialSummary.propTypes = {
  subtotalMoney: PropTypes.number.isRequired,
  subtotalPoints: PropTypes.number.isRequired,
  coupon: PropTypes.shape({
    discountMoney: PropTypes.number,
    discountPoints: PropTypes.number,
    code: PropTypes.string,
  }),
  totalMoney: PropTypes.number.isRequired,
  totalPoints: PropTypes.number.isRequired,
  displayMode: PropTypes.oneOf(["money", "points", "both"]).isRequired,
};
